import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faLock, faDesktop, faCloud } from '@fortawesome/free-solid-svg-icons';
import styles from './SecuritySection.module.css';

const SecuritySection = () => {
  return (
    <section id="security-section" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.badge}>Security & Access</span>
          <h2 className={styles.title}>Data handling is explicit by mode.</h2>
          <p className={styles.subtitle}>
            Litigation finance files carry privileged strategy, deal economics, and sensitive
            evidence. VerdeKai separates local analysis, protected collaboration, and opt-in
            cloud inference so teams can match workflow to policy.
          </p>
        </div>

        <div className={styles.mechanismRow}>
          <div className={styles.mechanismItem}>
            <div className={styles.mechanismIcon}>
              <FontAwesomeIcon icon={faDesktop} />
            </div>
            <div className={styles.mechanismText}>
              <span className={styles.mechanismLabel}>Local Analysis Option</span>
              <span className={styles.mechanismDesc}>Run inference through the local AI Engine when data policy requires it</span>
            </div>
          </div>
          <div className={styles.mechanismItem}>
            <div className={styles.mechanismIcon}>
              <FontAwesomeIcon icon={faLock} />
            </div>
            <div className={styles.mechanismText}>
              <span className={styles.mechanismLabel}>Protected Storage & Messaging</span>
              <span className={styles.mechanismDesc}>Keys stay client-side for encrypted collaboration and stored communications</span>
            </div>
          </div>
          <div className={styles.mechanismItem}>
            <div className={styles.mechanismIcon}>
              <FontAwesomeIcon icon={faCloud} />
            </div>
            <div className={styles.mechanismText}>
              <span className={styles.mechanismLabel}>Cloud Fallback When Enabled</span>
              <span className={styles.mechanismDesc}>Managed cloud inference uses encryption in transit and memory-only handling for standard inference; operational metadata and limited provider exceptions may apply</span>
            </div>
          </div>
        </div>

        <div className={styles.ctaBox}>
          <FontAwesomeIcon icon={faShieldHalved} className={styles.ctaIcon} />
          <div className={styles.promiseContent}>
            <h4 className={styles.promiseTitle}>Private beta access</h4>
            <p className={styles.promiseText}>
              We are opening VerdeKai to friendly testers who can pressure-test the workflow
              against real underwriting process.
            </p>
          </div>
          <a
            href="mailto:support@verdekai.com?subject=VerdeKai%20Beta%20Access"
            className={styles.primaryCta}
          >
            Request Beta Access
          </a>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
